module.exports = __webpack_public_path__ + "img/hongyun.7412facc.gif";